<template>
  <div class="PicInfo" v-if="picInfoIsShow">

    <div class="pic-item">
      <div class="label">下载人数：</div>
      <div class="value">{{ picInfo.unum || 0 }}</div>
    </div>

    <div class="pic-item">
      <div class="label">昨日下载人数：</div>
      <div class="value">{{ picInfo.last_unum || 0  }}</div>
    </div>

    <div class="pic-item">
      <div class="label">浏览量：</div>
      <div class="value">{{ picInfo.glance || 0  }}</div>
    </div>

    <div class="pic-item">
      <div class="label">下载次数：</div>
      <div class="value">{{ picInfo.dnum || 0  }}</div>
    </div>

    <div class="pic-item">
      <div class="label">昨日下载次数：</div>
      <div class="value">{{ picInfo.last_dnum || 0  }}</div>
    </div>

    <div class="pic-item">
      <div class="label">收藏数：</div>
      <div class="value">{{ picInfo.collect || 0  }}</div>
    </div>

  </div>
</template>

<script>
export default {
  name: "PicInfo",
  props: {
    /* 详情 */
    picInfo: {
      type: Object,
      default: () => {
      }
    },
    picInfoIsShow: false
  }
}
</script>

<style lang="scss" scoped>
.PicInfo{
  width: 434px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin: 18px 0;
  .pic-item{
    width: 33.33%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    color: rgba(89, 96, 136, 0.65);
    line-height: 17px;
    letter-spacing: 1px;
    margin-bottom: 6px;
    .label{
      margin-right: 4px;
      white-space: nowrap;
    }
  }
}
</style>


<!--
  运营查看图片相关信息 module
-->
